import { Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import {
  LayoutPropertyColumn,
  EditBase,
} from '@/store/editor/types'

import MxEditor from '@/mixins/editor'
import { Editor, EditorField, EditorSection } from '@/store/entity/types'
import { EntityBase } from '@/store/types'
import _ from 'lodash'

const nsEditor = namespace('editor')

// note: a editor component is a component that may not even be a field! (no mounted etc)

@Component
export default class extends MxEditor {
  @nsEditor.Mutation('incrementLastKey')
  public incrementLastKey!: any

  @nsEditor.State('lastKey')
  public lastKey!: number

  @Prop()
  public editor!: Editor // eventually this will replace the LayoutProperty completely

  // // old!
  // @Prop()
  // public column!: LayoutPropertyColumn // the field we're editing

  @Prop()
  public parentColumn!: LayoutPropertyColumn // the field we're editing

  // note: this can be idferent than column if we're using LayoutPropertyEditorType
  // - e.g. Values

  @Prop()
  public obj!: EditBase // the object that has the property we're editing

  @Prop()
  public parentObj!: EditBase

  @Prop()
  public originalObj!: any // the object that has the property we're editing

  @Prop({ type: Boolean, default: false })
  public multiple!: boolean

  @Prop()
  public sectionsReadOnly!: boolean

  @Prop()
  public addChildObject!: any

  @Prop()
  public addChildObjects!: any

  @Prop()
  public removeChildObject!: any

  @Prop()
  public readdChildObject!: any

  @Prop()
  public readOnly!: boolean

  public changed = false

  public isValid = true

  public failedRequired = true
  // public failedValidations: LayoutPropertyValidation[] = []

  get componentTitle() {
    return this.editor.EntityObject.titleProperties.map(c => this.obj[c.PropertyName]).join(':') || ''
  }

  public getComponentId(obj: EntityBase) {
    return this.getComponentIdByEntityObject(this.editor.EntityObject, obj)
  }

  public getTitle(obj: EntityBase) {
    return this.getTitleByEntityObject(this.editor.EntityObject, obj)
  }

  public getFieldDisplayName(editorField: EditorField) {
    return editorField.DisplayName ?? editorField.EntityProperty?.DisplayName
  }

  public getValueText(value: any) {
    if (value === undefined) {
      return '[undefined]'
    }

    if (value === null) {
      return '[null]'
    }

    if (value === true) {
      return '[true]'
    }

    if (value === false) {
      return '[false]'
    }

    if (value === '') {
      return '[blank]'
    }
    return value
  }

  public onChanged(changed: boolean) {
    const { obj } = this
    this.changed = changed
    // TODO: is this too often?
    this.setUpdated({ obj, value: changed })
    this.$emit('changed', this.changed)
  }

  public onValidated(valid: boolean) {
    this.isValid = valid
    this.$emit('validated', this.isValid)
  }

  public getNextKey() {
    this.incrementLastKey()
    return this.lastKey
  }

  public save(obj: EditBase, section: EditorSection) {
    this.$emit('save', obj, section)
  }

  public setDefaultFieldValue(editorField: EditorField, originalValue: any) {
    this.fieldValueUpdated(editorField, editorField.DefaultValue, originalValue)
  }

  // this is on the field itself, called editor-field.ts
  // TODO: we need to call somethings like this higher up?!
  public fieldValueUpdated(editorField: EditorField, value: any, originalValue: any) {
    const { obj, parentObj, parentColumn } = this
    if (this.editorLoading) { return }

    this.$nextTick()
    this.updateFieldValue({ obj, parentObj, editorField, parentColumn, value }).then(valid => {
      this.$nextTick()
      this.setFieldChanged(editorField, value, originalValue)
      this.isValid = valid
      this.onValidated(this.isValid)
      this.$emit('update-value', obj, editorField, value)
    })
  }

  public setFieldChanged(editorField: EditorField, value: any, originalValue: any) {
    // TODO: perhaps set updated of whatever this thing is?!
    const { obj } = this
    let changed = false
    if (value === undefined) {
      changed = (originalValue !== undefined)
    } else if (value === null) {
      changed = !!originalValue // because if it was undefined and now it's null no diff
    } else if (originalValue !== undefined && originalValue !== null) {
      switch (editorField.EditorType) {
        default:
          // this.changed = (this.originalValue !== value)
          // TODO: what if its the list that had a change? How was I handling that?
          // - I don't seem to be!
          changed = originalValue.length !== value.length ||
            !_.isEqual(originalValue, value) // isEqual should work for most cases, right?
      }
    } else if (value !== undefined || value !== null) {
      changed = true
    }
    if (changed !== this.changed) {
      this.setUpdated({ obj, value: true })
      this.onChanged(changed)
    }
  }
}
